import { render } from "./LongFong.vue?vue&type=template&id=baee5bfa&scoped=true"
import script from "./LongFong.vue?vue&type=script&lang=js"
export * from "./LongFong.vue?vue&type=script&lang=js"

import "./LongFong.vue?vue&type=style&index=0&id=baee5bfa&scoped=true&lang=css"

import exportComponent from "E:\\项目\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baee5bfa"]])

export default __exports__